let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lKUru")).then(() => parcelRequire('5tap4'));